import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class TimeConditionServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getTableList(params = {}) {
    return this.pure_http.get('/pbx/client/time-conditions', { params: params });
  }

  getSelect(params = {}) {
    return this.pure_http.get(`/pbx/client/select/time-conditions`, { params: params });
  }
}

export const TimeConditionService = new TimeConditionServiceClass({
  api_version: 2,
  resource: 'pbx/time-conditions'
});
